<template>
  <div v-loading.fullscreen.lock="addressesLoading">
    <el-form-item
      class="mt-2"
      prop="address.post_code"
    >
      <template slot="label">
        Post code/Zip code
        <span
          class="sr-only"
          aria-live="polite"
          :hidden="!hasInlineValidationErrorFor('address.post_code')"
          v-text="getInlineValidationErrorFor('address.post_code')"
        ></span>
      </template>

      <div class="d-flex">
        <el-input
          id="postcode"
          v-model="cloneAddress.post_code"
          name="Postcode"
          class="half-flex-content"
          maxlength="30"
          autocomplete="false"
          label="Please enter post code in this field"
          aria-required="true"
          @blur="cloneAddress.post_code = cloneAddress.post_code.trim()"
          @input="disableAddressLookup = false"
          @keypress.enter.native="onFindAddress($event)"
        />

        <div class="mr-3"></div>

        <el-form-item class="half-flex-content">
          <el-button
            size="medium"
            :disabled="disableAddressLookup || cloneAddress.post_code.trim().length == 0"
            @click="onFindAddress($event)"
          >
            Find address
          </el-button>
        </el-form-item>
      </div>
    </el-form-item>
    <el-form-item v-if="availableMailingAddresses.length > 0">
      <template slot="label">
        <span aria-hidden="true">Addresses Found</span>
        <span class="sr-only">Please select your address</span>
      </template>
      <v-select
        v-model="selectedAvailableMailingAddress"
        placeholder="Please select"
        :options="availableMailingAddresses"
        :searchable="true"
        :clearable="false"
        label="Text"
        input-id="available_mailing_addresses"
        autocomplete="false"
        @input="onAvailableMailingAddressSelected($event)"
      />
    </el-form-item>
    <el-form-item
      prop="address.address_1"
      :required="required"
    >
      <template slot="label">
        Address line 1
        <span
          class="sr-only"
          aria-live="polite"
          :hidden="!hasInlineValidationErrorFor('address.address_1')"
          v-text="getInlineValidationErrorFor('address.address_1')"
        ></span>
      </template>
      <el-input
        id="address.address_1"
        v-model="cloneAddress.address_1"
        maxlength="255"
        autocomplete="false"
        label="Please enter mailing address line 1 in this field"
        aria-required="true"
        @blur="cloneAddress.address_1 = cloneAddress.address_1.trim()"
      />
    </el-form-item>
    <el-form-item prop="address.address_2">
      <template slot="label">
        Address line 2 - Optional
        <span
          class="sr-only"
          aria-live="polite"
          :hidden="! hasInlineValidationErrorFor('address.address_2')"
          v-text="getInlineValidationErrorFor('address.address_2')"
        ></span>
      </template>
      <el-input
        id="mailing_address_2"
        v-model="cloneAddress.address_2"
        maxlength="255"
        autocomplete="false"
        label="Please enter mailing address line 2 in this field"
        @blur="cloneAddress.address_2 = cloneAddress.address_2.trim()"
      />
    </el-form-item>
    <el-form-item
      prop="address.town"
      :required="required"
    >
      <template slot="label">
        Town, City or State
        <span
          class="sr-only"
          aria-live="polite"
          :hidden="! hasInlineValidationErrorFor('address.town')"
          v-text="getInlineValidationErrorFor('address.town')"
        ></span>
      </template>
      <el-input
        id="address.town"
        v-model="cloneAddress.town"
        maxlength="100"
        autocomplete="false"
        label="Please enter mailing town, city or state in this field"
        aria-required="true"
        @blur="cloneAddress.town = cloneAddress.town.trim()"
      />
    </el-form-item>
    <el-form-item prop="address.county">
      <template slot="label">
        Region - Optional
        <span
          class="sr-only"
          aria-live="polite"
          :hidden="! hasInlineValidationErrorFor('address.county')"
          v-text="getInlineValidationErrorFor('address.county')"
        ></span>
      </template>
      <el-input
        id="address.county"
        v-model="cloneAddress.county"
        maxlength="100"
        autocomplete="false"
        label="Please enter mailing region in this field"
        @blur="cloneAddress.county = cloneAddress.county.trim()"
      />
    </el-form-item>
  </div>
</template>
<script>
import loqateApi from '@/services/loqate.api'
import inlineValidationErrorsMixin from '@/mixins/inlineValidationErrorsMixin'
export default{
  name:"AddressComponent",
  mixins: [inlineValidationErrorsMixin],
  props:{
    address: {
      type: Object,
      default: ()=> {}
    },
    required:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      cloneAddress: {},
      addressesLoading: false,
      disableAddressLookup: false,
      availableMailingAddresses: [],
      selectedAvailableMailingAddress: null
    }
  },
  watch:{
    cloneAddress :{
      deep: true,
      handler(newVal, oldVal){
        if(oldVal.address_1){
          this.$emit("update", newVal)
        }
      }
    }
  },

  created(){
    this.cloneAddress = JSON.parse(JSON.stringify(this.address))
  },
  methods:{
    onFindAddress (e) {
      e.preventDefault()
      this.findAddresses(this.cloneAddress.post_code)
    },
    findAddresses (value, containerId='') {
      this.addressesLoading = true
      loqateApi.find(value, containerId, '')
        .then(response => {
          

          if (response.data && response.data.Items && response.data.Items.length > 0) {
            if (response.data.Items[0].Error) {
              this.$alert('Failed to find any addresses using postcode provided. Please enter mailing address details instead.', 'No addresses found', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
            } else if (response.data.Items[0].Type != "Address") {
              this.findAddresses(value, response.data.Items[0].Id)
            } else if (!response.data.Items[0].Error) {
              this.cloneAddress.address_1 = ''
              this.cloneAddress.address_2 = ''
              this.cloneAddress.town = ''
              this.cloneAddress.county = ''
              this.cloneAddress.country_id = null

              this.disableAddressLookup = true
              this.availableMailingAddresses = response.data.Items
              
            }
          } else {
            this.availableMailingAddresses = []
            this.$alert('Failed to find any addresses using postcode provided. Please enter mailing address details instead.', 'No addresses found', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
          }
        })
        .catch((error) => {
          console.log(error)
          this.availableMailingAddresses = []
          this.$alert('Failed to find any addresses using postcode provided. Please enter mailing address details instead.', 'No addresses found', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        }).finally(() => {
          this.addressesLoading = false
        });
    },
    onAvailableMailingAddressSelected (address) {
      this.retrieveAddress(address.Id)
    },
    retrieveAddress (id) {
      loqateApi.retrieve(id)
        .then(response => {
          if (response.data && response.data.Items && response.data.Items.length == 1 && !response.data.Items[0].Error) {
            this.disableAddressLookup = true

            let address = response.data.Items[0]
            this.cloneAddress.address_1 = address.Line1
            this.cloneAddress.address_2 = address.Line2
            this.cloneAddress.post_code = address.PostalCode
            this.cloneAddress.town = address.City
            this.cloneAddress.county = address.AdminAreaName

            //let country = this.countries.find(c => (c.code == address.CountryIso2 || c.code == address.CountryIso3))

            this.cloneAddress.country_id = 235; // by default GB
            /*if (country) {
              this.cloneAddress.country_id = country.id
            }*/
          } else {
            this.$alert('Failed to automatically use the selected address. Please enter address details instead.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
          }
        })
        .catch(error => {
          this.$alert('Failed to automatically use the selected address. Please enter address details instead.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        })
    },
  }
}
</script>